/*
REFERENCE: https://drive.google.com/file/d/1-imKqRIjula5jPXWsLp1fzHLwoaElI9X/view

USAGE EXAMPLE:

pushData({
  event: 'fileDownload',
  eventType: 'pdf',
  componentType: 'hero',
  componentTitle: title,
  componentLink: download.link,
  componentLinkText: download.button,
})
*/

const eventData = {
  internalLink: {
    name: "internal_link",
    type: ["menu"]
  },
  externalLink: {
    name: "external_link",
    type: []
  },
  fileDownload: {
    name: "file_download",
    type: ["pdf", "image", "excel", "calendar", "doc", "presentation", "zip", "transcript"]
  },
  linkShare: {
    name: "link_share",
    type: ["facebook", "twitter", "linkedin", "email", "link"]
  },
  accordion: {
    name: "accordion",
    type: ["open", "close"]
  },
  filterAction: {
    name: "filter",
    type: ["filter_type", "filter_from", "filter_to"]
  },
  contactMailTo: {
    name: "contact",
    type: ["mail"]
  },
  contactPhone: {
    name: "contact",
    type: ["phone"]
  },
  sliderAction: {
    name: "slider",
    type: ["next", "prev"]
  },
  mapAction: {
    name: "map",
    type: ["pin"]
  },
  searchSubmit: {
    name: "search_submit",
    type: []
  }
};

export function pushData({ event, eventType, componentType, componentTitle, componentLink, componentLinkText } = {}) {
  const data = {
    event: event,
    eventDetail: {
      name: eventData[event].name,
      type: eventType,
      'component.type': componentType, // e.g. 'hero-banner'
      'component.title': componentTitle, // e.g. 'the title',
      'component.link': componentLink, // e.g. 'https://www.site.com/the-link',
      'component.linkText': componentLinkText // e.g. 'Go to the page'
    }
  }
  console.log(data);
  window.digitalData.push(data);
}